import { motion } from "framer-motion";
import styled from "styled-components";

export const SocialsWrapper = styled.div`
  @media (max-width: 800px) {
    display: none;
  }
`;

export const LeftSocialBar = styled(motion.div)`
  position: fixed;
  bottom: 0;
  left: 76px;
  height: 308px;
  width: 55px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* background-color: purple; */
  @media (max-width: 1600px) {
    left: 40px;
    height: 220px;
  }
`;

export const IconsWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  /* gap: 40px; */
  > * + * {
    margin-top: 40px;
  }
  :hover & {
    color: var(--main-color);
  }
  a:hover svg {
    stroke: var(--main-color);
  }
`;

export const VerticalLineLeft = styled.div`
  position: absolute;
  bottom: 0;
  width: 1px;
  height: 100px;
  background-color: #fff;
`;

/*------------------------------------------------------------------------------------------*/
export const RightSocialBar = styled(motion.div)`
  position: fixed;
  bottom: 0;
  right: 76px;
  height: 308px;
  width: 55px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* background-color: purple; */
  @media (max-width: 1600px) {
    right: 40px;
    height: 280px;
  }
`;

export const EmailText = styled.div`
  position: absolute;
  font-family: "Raleway", sans-serif;
  font-weight: 200;
  font-size: 14px;
  writing-mode: vertical-rl;
  /* transform: rotate(90deg); */
  /* text-orientation: upright; */
`;

export const VerticalLineRight = styled.div`
  position: absolute;
  bottom: 0;
  width: 1px;
  height: 100px;
  background-color: #fff;
  @media (max-width: 1300px) {
    /* right: 51px; */
  }
`;
/*------------------------------------------------------------------------------------------*/
export const IconNames = styled.div`
  font-family: "Raleway", sans-serif;
  font-weight: 200;
  font-size: 14px;
  @media (max-width: 1600px) {
    display: none;
  }
`;

export const IconTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  > * + * {
    margin-top: 10px;
  }
`;
